Object.defineProperty(exports, "__esModule", { value: true });
var PanesActionTypes;
(function (PanesActionTypes) {
    PanesActionTypes["INIT_PANES_NAMESPACE"] = "@@edikit/panes/INIT_PANES_NAMESPACE";
    PanesActionTypes["SET_CURRENT_PANE"] = "@@edikit/panes/SET_CURRENT_PANE";
    PanesActionTypes["ADD_CONTENT_TO_CURRENT_PANE"] = "@@edikit/panes/ADD_CONTENT_TO_CURRENT_PANE";
    PanesActionTypes["SET_PANE_CURRENT_CONTENT"] = "@@edikit/panes/SET_PANE_CURRENT_CONTENT";
    PanesActionTypes["REMOVE_PANE_CONTENT"] = "@@edikit/panes/REMOVE_PANE_CONTENT";
    PanesActionTypes["REMOVE_CONTENT_FROM_ALL_PANES"] = "@@edikit/panes/REMOVE_CONTENT_FROM_ALL_PANES";
    PanesActionTypes["SPLIT_PANE"] = "@@edikit/panes/SPLIT_PANE";
})(PanesActionTypes = exports.PanesActionTypes || (exports.PanesActionTypes = {}));
